import { InternalAxiosRequestConfig } from 'axios'

import { GetValidAccessToken } from '../../api/refresh-token'

export function authTokenInterceptor() {
  return async (
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> => {
    const token = await GetValidAccessToken()
    const skipAuthToken = config.params?.is_public ?? false
    if (!skipAuthToken && token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  }
}
